"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sync = exports.scanAccounts = exports.getAccountShape = void 0;
var jsHelpers_1 = require("../../bridge/jsHelpers");
var jsHelpers_2 = require("../../bridge/jsHelpers");
var account_1 = require("../../account");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var ledgerjs_hw_app_cardano_1 = __importDefault(require("@cardano-foundation/ledgerjs-hw-app-cardano"));
var utils_1 = require("@cardano-foundation/ledgerjs-hw-app-cardano/dist/utils");
var typhonjs_1 = require("@stricahq/typhonjs");
var logic_1 = require("./logic");
var operation_1 = require("../../operation");
var networks_1 = require("./networks");
var getNetworkInfo_1 = require("./api/getNetworkInfo");
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var postSyncPatch_1 = __importDefault(require("./postSyncPatch"));
var getTransactions_1 = require("./api/getTransactions");
var buildSubAccounts_1 = require("./buildSubAccounts");
var utils_2 = require("@stricahq/typhonjs/dist/utils/utils");
var currencies_1 = require("../../currencies");
function mapTxToAccountOperation(tx, accountId, accountCredentialsMap, subAccounts) {
    var accountChange = (0, logic_1.getAccountChange)(tx, accountCredentialsMap);
    var mainOperationType = (0, logic_1.getOperationType)({
        valueChange: accountChange.ada,
        fees: new bignumber_js_1["default"](tx.fees)
    });
    var subOperations = (0, account_1.inferSubOperations)(tx.hash, subAccounts);
    var memo = (0, logic_1.getMemoFromTx)(tx);
    var extra = {};
    if (memo) {
        extra["memo"] = memo;
    }
    return {
        accountId: accountId,
        id: (0, operation_1.encodeOperationId)(accountId, tx.hash, mainOperationType),
        hash: tx.hash,
        type: mainOperationType,
        fee: new bignumber_js_1["default"](tx.fees),
        value: accountChange.ada.absoluteValue(),
        senders: tx.inputs.map(function (i) {
            return (0, logic_1.isHexString)(i.address)
                ? typhonjs_1.utils.getAddressFromHex(i.address).getBech32()
                : i.address;
        }),
        recipients: tx.outputs.map(function (o) {
            return (0, logic_1.isHexString)(o.address)
                ? typhonjs_1.utils.getAddressFromHex(o.address).getBech32()
                : o.address;
        }),
        subOperations: subOperations,
        blockHeight: tx.blockHeight,
        date: new Date(tx.timestamp),
        extra: extra,
        blockHash: undefined
    };
}
function prepareUtxos(newTransactions, stableUtxos, accountCredentialsMap) {
    var newUtxos = [];
    // spentUtxoKey = txId#index
    var spentUtxoKeys = new Set();
    newTransactions.forEach(function (t) {
        t.inputs.forEach(function (i) {
            var cred = accountCredentialsMap[i.paymentKey];
            if (cred)
                spentUtxoKeys.add("".concat(i.txId, "#").concat(i.index));
        });
        t.outputs.forEach(function (o, outputIndex) {
            var cred = accountCredentialsMap[o.paymentKey];
            if (cred) {
                newUtxos.push({
                    hash: t.hash,
                    index: outputIndex,
                    address: o.address,
                    amount: new bignumber_js_1["default"](o.value),
                    tokens: o.tokens.map(function (token) { return ({
                        assetName: token.assetName,
                        policyId: token.policyId,
                        amount: new bignumber_js_1["default"](token.value)
                    }); }),
                    paymentCredential: {
                        key: o.paymentKey,
                        path: cred.path
                    }
                });
            }
        });
    });
    var utxos = (0, uniqBy_1["default"])(__spreadArray(__spreadArray([], __read(stableUtxos), false), __read(newUtxos), false), function (u) { return "".concat(u.hash, "#").concat(u.index); }).filter(function (u) { return !spentUtxoKeys.has("".concat(u.hash, "#").concat(u.index)); });
    return utxos;
}
var getAccountShape = function (info, _a) {
    var blacklistedTokenIds = _a.blacklistedTokenIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var transport, currency, accountIndex, derivationPath, derivationMode, initialAccount, rootPath, accountPath, paramXpub, extendedPubKeyRes, ada, xpub, accountId, syncHash, outdatedSyncHash, requiredConfirmations, oldOperations, lastBlockHeight, syncFromBlockHeight, _b, newTransactions, blockHeight, externalCredentials, internalCredentials, accountCredentialsMap, stableOperationsByIds, stableUtxos, utxos, accountBalance, tokenBalance, subAccounts, newOperations, operations, stakeCredential, networkParams, freshAddresses, cardanoNetworkInfo, minAdaBalanceForTokens;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    transport = info.transport, currency = info.currency, accountIndex = info.index, derivationPath = info.derivationPath, derivationMode = info.derivationMode, initialAccount = info.initialAccount;
                    rootPath = derivationPath.split("/", 2).join("/");
                    accountPath = "".concat(rootPath, "/").concat(accountIndex, "'");
                    paramXpub = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.xpub;
                    if (!!paramXpub) return [3 /*break*/, 2];
                    if (!transport) {
                        // hwapp not provided
                        throw new Error("hwapp required to generate the xpub");
                    }
                    ada = new ledgerjs_hw_app_cardano_1["default"](transport);
                    return [4 /*yield*/, ada.getExtendedPublicKey({
                            path: (0, utils_1.str_to_path)(accountPath)
                        })];
                case 1:
                    extendedPubKeyRes = _d.sent();
                    _d.label = 2;
                case 2:
                    xpub = paramXpub ||
                        "".concat(extendedPubKeyRes.publicKeyHex).concat(extendedPubKeyRes.chainCodeHex);
                    accountId = (0, account_1.encodeAccountId)({
                        type: "js",
                        version: "2",
                        currencyId: currency.id,
                        xpubOrAddress: xpub,
                        derivationMode: derivationMode
                    });
                    syncHash = JSON.stringify(blacklistedTokenIds || []) +
                        "_" +
                        (0, currencies_1.listTokensForCryptoCurrency)(currency, {
                            withDelisted: true
                        }).length;
                    outdatedSyncHash = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.syncHash) !== syncHash;
                    requiredConfirmations = 90;
                    oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
                    lastBlockHeight = oldOperations.length
                        ? (oldOperations[0].blockHeight || 0) + 1
                        : 0;
                    syncFromBlockHeight = outdatedSyncHash
                        ? 0
                        : lastBlockHeight > requiredConfirmations
                            ? lastBlockHeight - requiredConfirmations
                            : 0;
                    return [4 /*yield*/, (0, getTransactions_1.getTransactions)(xpub, accountIndex, initialAccount, syncFromBlockHeight, currency)];
                case 3:
                    _b = _d.sent(), newTransactions = _b.transactions, blockHeight = _b.blockHeight, externalCredentials = _b.externalCredentials, internalCredentials = _b.internalCredentials;
                    accountCredentialsMap = __spreadArray(__spreadArray([], __read(externalCredentials), false), __read(internalCredentials), false).reduce(function (finalMap, cred) {
                        finalMap[cred.key] = cred;
                        return finalMap;
                    }, {});
                    stableOperationsByIds = {};
                    ((initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || []).forEach(function (o) {
                        if (o.blockHeight < syncFromBlockHeight) {
                            stableOperationsByIds[o.hash] = o;
                        }
                    });
                    stableUtxos = (((_c = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.cardanoResources) === null || _c === void 0 ? void 0 : _c.utxos) || []).filter(function (u) { return stableOperationsByIds[u.hash]; });
                    utxos = prepareUtxos(newTransactions, stableUtxos, accountCredentialsMap);
                    accountBalance = utxos.reduce(function (total, u) { return total.plus(u.amount); }, new bignumber_js_1["default"](0));
                    tokenBalance = (0, logic_1.mergeTokens)(utxos.map(function (u) { return u.tokens; }).flat());
                    subAccounts = (0, buildSubAccounts_1.buildSubAccounts)({
                        initialAccount: initialAccount,
                        parentAccountId: accountId,
                        parentCurrency: currency,
                        newTransactions: newTransactions,
                        tokens: tokenBalance,
                        accountCredentialsMap: accountCredentialsMap
                    }).filter(function (a) { return !(blacklistedTokenIds === null || blacklistedTokenIds === void 0 ? void 0 : blacklistedTokenIds.includes(a.token.id)); });
                    newOperations = newTransactions.map(function (t) {
                        return mapTxToAccountOperation(t, accountId, accountCredentialsMap, subAccounts);
                    });
                    operations = (0, jsHelpers_1.mergeOps)(Object.values(stableOperationsByIds), newOperations);
                    stakeCredential = (0, logic_1.getAccountStakeCredential)(xpub, accountIndex);
                    networkParams = (0, networks_1.getNetworkParameters)(currency.id);
                    freshAddresses = externalCredentials
                        .filter(function (c) { return !c.isUsed; })
                        .map(function (c) { return ({
                        derivationPath: (0, logic_1.getBipPathString)(c.path),
                        address: (0, logic_1.getBaseAddress)({
                            networkId: networkParams.networkId,
                            paymentCred: c,
                            stakeCred: stakeCredential
                        }).getBech32()
                    }); });
                    return [4 /*yield*/, (0, getNetworkInfo_1.getNetworkInfo)(initialAccount, currency)];
                case 4:
                    cardanoNetworkInfo = _d.sent();
                    minAdaBalanceForTokens = tokenBalance.length
                        ? (0, utils_2.calculateMinUtxoAmount)(tokenBalance, new bignumber_js_1["default"](cardanoNetworkInfo.protocolParams.lovelacePerUtxoWord), false)
                        : new bignumber_js_1["default"](0);
                    return [2 /*return*/, {
                            id: accountId,
                            xpub: xpub,
                            balance: accountBalance,
                            spendableBalance: accountBalance.minus(minAdaBalanceForTokens),
                            operations: operations,
                            syncHash: syncHash,
                            subAccounts: subAccounts,
                            freshAddresses: freshAddresses,
                            freshAddress: freshAddresses[0].address,
                            freshAddressPath: freshAddresses[0].derivationPath,
                            blockHeight: blockHeight,
                            cardanoResources: {
                                utxos: utxos,
                                externalCredentials: externalCredentials,
                                internalCredentials: internalCredentials,
                                protocolParams: cardanoNetworkInfo.protocolParams
                            }
                        }];
            }
        });
    });
};
exports.getAccountShape = getAccountShape;
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: exports.getAccountShape });
exports.sync = (0, jsHelpers_2.makeSync)({ getAccountShape: exports.getAccountShape, postSync: postSyncPatch_1["default"] });
//# sourceMappingURL=js-synchronisation.js.map